import { render, staticRenderFns } from "./MediaDevicesSelector.vue?vue&type=template&id=8ec3f108&scoped=true"
import script from "./MediaDevicesSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaDevicesSelector.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MediaDevicesSelector.vue?vue&type=style&index=0&id=8ec3f108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec3f108",
  null
  
)

export default component.exports